<div *ngIf="display_sponsor">
    <a [href]="display_sponsor.url" target="_blank">
        <div class="sp-container">
            <img class="sp-image" [src]="display_sponsor.image_url" alt="">
        </div>
    </a>
</div>